<template>
    <div>
        <div class="enterprise-container">
            <img class="logo" src="/media/images/web_search/open_talent.png" alt="Logo" />
            <div class="separator"></div>
            <div class="main-topic text-content">
                <h2>Open Talent Cloud für HR:<br /> Alle externen Talente auf einen Blick</h2>
                <p>
                    HR‘ler wissen es: Externe verwaltet man anders als Interne. Die Deutsche Interim AG ist
                    spezialisiert
                    auf das Management externer Mitarbeiter und bietet Unternehmen eine Open Talent Plattform, um alle
                    Externen – egal aus welchen Quellen – an einem Ort verwalten und rechtssicher einsetzen und
                    abrechnen zu
                    können.
                </p>
            </div>
        </div>
        <div class="tile-row-two">
            <div class="tile-box">
                <h3>Die unternehmenseigene Open Talent Cloud</h3>
                <p>
                    Verwalten Sie die Profile aller Externen aus Ihrem Firmennetzwerk an einer zentralen Stelle. <br />
                    <b>Kandidaten-Profile:</b> Laden Sie beliebige CV-Profile aller Externer in ihre unternehmens-eigene
                    Open Talent Cloud zu der nur Ihre Organisation Zugang hat. <br />
                    <b>Pool-Erweiterung:</b> Erweitern Sie die Open Talent Cloud Ihres Unternehmens nach Bedarf mit
                    Profilen externer Anbieter. <br />
                    <b>Staffing-Listen:</b> Führen Sie Staffing-Listen für typische Bedarfssituationen Ihres
                    Unternehmens.
                </p>
            </div>
            <div class="tile-box tile-image-only">
                <img class="tile-logo" src="/media/images/web_search/open_talent_cloud.jpg" alt="Logo" />
            </div>
        </div>
        <div class="tile-row-two">
            <div class="tile-box tile-image-only">
                <img class="tile-logo" src="/media/images/web_search/project_externer_administrieren.jpg" alt="Logo" />
            </div>
            <div class="tile-box">
                <h3>Projekteinsätze Externer administrieren</h3>
                <p>
                    Mit der Open Talent Cloud der Deutschen Interim AG können Sie die Projekteinsätze Externer an einem
                    Ort verwalten <br />
                    <b>Kandidatenauswahl:</b> Staffen Sie aus Ihrer Open Talent Cloud Projekte mit externen Kandidaten
                    aus beliebigen Quellen. Führen Sie als HR-Verantwortlicher den Auswahl-Prozess und binden Sie
                    Kollegen aus den Abteilungen mit ein. <br />
                    <b>Tätigkeitsnachweise:</b> Tätigkeitsnachweise können direkt in der Anwendung erstellt werden. Die
                    Genehmigung und Freigabe wird mit elektronischen Unterschriften unterstützt. <br />
                    <b>Projektabrechnungen:</b> Erstellung von Projektabrechnungen im Gutschriftsverfahren mit
                    Schnittstellen zu Buchführungssystemen wie Datev.
                </p>
            </div>
        </div>
        <div class="tile-row-two">
            <div class="tile-box">
                <h2>Vertragsmanagement</h2>
                <p>
                    Die Deutschen Interim AG unterstützt Sie in der Auswahl Ihrer Vertragsoptionen für eine
                    rechtssichere Projektabwicklung. <br />
                    <b>Vertragsmanagement:</b> Egal ob Dienstleistungsvertrag, Arbeitnehmer-Überlassung, ANÜ-Payrolling,
                    befristete Anstellung oder Werksvertrag. Wir finden mit Ihnen für jede Einsatzart die richtige
                    Vertragsform. <br />
                    <b>Versicherung & Haftung:</b> Auf Wunsch stellen wir den richtigen Versicherungsschutz für Ihre
                    Externen, damit sie gegen Schadensfälle ausreichend abgesichert sind. <br />
                    <b>Compliance-Check:</b> Auf Wunsch dokumentieren wir anhand von Checklisten den Einsatz der
                    Externen in Ihrem Unternehmen um den Nachweispflichten Ihres Unternehmens nachzukommen. <br />
                </p>
            </div>
            <div class="tile-box tile-image-only">
                <img class="tile-logo" src="/media/images/web_search/vertragsmanagement.jpg" alt="Logo" />
            </div>
        </div>
        <div class="contact-container">
            <img class="logo avatar" src="/media/images/web_search/tilo_ceo.jpg" alt="Logo" />
            <div class="separator"></div>
            <div class="text-content">
                <h2>Tilo Ferrari / CEO</h2>
                <p>
                    Sie wollen eine Open Talent Cloud <br />für Ihr Unternehmen aufbauen? Dann lassen Sie uns sprechen!
                </p>
                <div class="socials d-flex flex-row justify-content-center">
                    <div class="mail">
                        <a href="mailto:tilo.ferrari@deutscheinterim.com">tilo.ferrari@deutscheinterim.com</a>

                    </div>
                    <div class="phone">
                        <a href="tel:+49-69-173201231">+49 69 173201231</a>

                    </div>
                    <div class="calendly">
                        <a href="https://calendly.com/tiloferrari/informationsgespraech"
                            target="_blank">https://calendly.com/tiloferrari/informationsgespraech</a>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "Enterprise",
};
</script>

<style scoped>
.enterprise-container {
    display: flex;
    align-items: flex-start;
    background: #CDDEE2;
    padding: 20px;
    border-radius: 12px;
    border-top-left-radius: 0;
    margin: 0 auto;
}

.contact-container {
    display: flex;
    align-items: flex-start;
    padding: 20px;
    border-top-left-radius: 0;
    margin: 0 auto;
    background-color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    padding: 24px;
    display: flex;
    margin-top: 24px;
    margin-bottom: 33px;
}

.logo {
    width: 185px;
    height: auto;
    margin-top: 15px;
}

.separator {
    width: 6px;
    background-color: #338EA3;
    height: 100%;
    min-height: 290px;
    margin-left: 30px;
    margin-right: 30px;
}

.text-content {
    max-width: 700px;
}

.main-topic h2 {
    text-align: left;
    font: normal normal 500 42px/48px Cormorant Garamond;
    letter-spacing: -0.84px;
    color: #191919;
    opacity: 1;
}

.main-topic p {
    text-align: left;
    font: normal normal normal 20px/30px Barlow;
    letter-spacing: -0.4px;
    color: #000000;
    opacity: 1;
}

p {
    font-size: 16px;
    line-height: 1.5;
}

.tile-row-two {
    display: flex;
    gap: 20px;
    margin-top: 30px;
    align-items: stretch;
}

.tile-box {
    flex: 1 1 auto;
    background-color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    padding: 24px;
    flex-direction: column;
    justify-content: center;
}

.tile-box h3 {
    text-align: left;
    font: normal normal 500 28px/32px Barlow;
    letter-spacing: -0.56px;
    color: #191919;
    opacity: 1;
}

.tile-box p {
    text-align: left;
    font: normal normal normal 20px/30px Barlow;
    letter-spacing: -0.4px;
    color: #000000;
}

.tile-image-only {
    flex: 0 0 325px;
    display: flex;
    align-items: stretch;
    justify-content: center;
    text-align: center;
}

.tile-image-only img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 18px;
}

.contact-container h2 {
    text-align: left;
    font: italic normal normal 26px/55px Barlow;
    letter-spacing: -0.52px;
    color: #191919;
    opacity: 1;
}

.contact-container p {
    text-align: left;
    font: normal normal 500 36px/42px Cormorant Garamond;
    letter-spacing: -0.72px;
    color: #191919;
    opacity: 1;
}

.logo.avatar {
    border-radius: 50%;
    width: 260px;
}

.mail a {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
    font-size: 0;
    margin: 4px 7px;
    background-image: url(/media/images/web_search/mail.svg);
}

.phone a {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
    font-size: 0;
    margin: 4px 7px;
    background-image: url(/media/images/web_search/phone.svg);
}

.calendly a {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
    font-size: 0;
    margin: 4px 7px;
    background-image: url(/media/images/web_search/calendar.svg);
}

.socials {
    display: flex;
}

@media (max-width: 768px) {
    .enterprise-container,
    .contact-container {
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 16px;
    }

    .separator {
        display: none;
    }

    .text-content {
        max-width: 100%;
        padding: 0 10px;
    }

    .main-topic h2 {
        font-size: 28px;
        line-height: 36px;
        text-align: center;
    }

    .main-topic p {
        font-size: 16px;
        line-height: 24px;
        text-align: center;
    }

    .tile-row-two {
        flex-direction: column;
        gap: 16px;
    }

    .tile-box {
        padding: 16px;
    }

    .tile-box h3 {
        font-size: 24px;
        line-height: 30px;
        text-align: center;
    }

    .tile-box p {
        font-size: 16px;
        line-height: 24px;
        text-align: center;
    }

    .tile-image-only {
        flex: 1 1 auto;
    }

    .tile-image-only img {
        height: auto;
    }

    .logo {
        width: 140px;
        margin-top: 10px;
    }

    .logo.avatar {
        width: 180px;
    }

    .contact-container h2 {
        font-size: 20px;
        line-height: 28px;
        text-align: center;
    }

    .contact-container p {
        font-size: 24px;
        line-height: 32px;
        text-align: center;
    }

    .socials {
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 16px;
    }

    .mail a, .phone a, .calendly a {
        width: 40px;
        height: 40px;
        margin: 6px;
    }
}

</style>